/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-danger */
import * as React from 'react';

import { FaqItem } from './faq-item/faq-item';
import { FaqSection } from './faqs.styles';

interface FaqsProps {
  faqTitle: string;
  faqs: { answer: string; question: string }[];
}

const Faqs = ({ faqTitle, faqs }: FaqsProps) => {
  return (
    <FaqSection>
      <div className="content-info">
        <div
          dangerouslySetInnerHTML={{
            __html: faqTitle,
          }}
        />
      </div>

      <div className="faq-container">
        {faqs.map(({ answer, question }, index) => {
          return (
            <FaqItem
              key={`faq-${String(index)}`}
              index={`faq-${index}`}
              question={question}
              answer={answer}
            />
          );
        })}
      </div>
    </FaqSection>
  );
};

export { Faqs };
